import React, { useRef, useState, useEffect } from "react";

type Props = {
  appName?: string;
  companyName?: string;
  jurisdiction?: string;
  effectiveDate?: string;
  onAccept?: () => void;
  onDecline?: () => void;
};

export default function TermsAndCondition() {


  return (
   <div className="terms-page">
  <style>
   {`
    .terms-page {
      background-color: white;
      color: black;
      min-height: 100vh;
      padding: 60px 200px; /* 🟢 200px left & right spacing */
      font-family: Arial, sans-serif;
      text-align: left;
    }

    .terms-header {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 40px;
    }

    .terms-header img {
      width: 40px;
      height: 40px;
    }

    .terms-header h1 {
      font-size: 28px;
      font-weight: bold;
      color: black;
      margin: 0;
    }

    .terms-content h2 {
      font-size: 20px;
      color: black;
      margin-top: 25px;
      margin-bottom: 5px;
      line-Height:0.8;
    }

    .terms-content p {
      font-size: 16px;
      color: black;
      line-height: 1.4; /* slightly tighter line spacing */
      margin-top: 5px;
      margin-bottom: 15px;
    }

    @media (max-width: 768px) {
      .terms-page {
        padding: 40px 30px; /* smaller screen spacing */
      }

      .terms-header h1 {
        font-size: 22px;
      }

      .terms-content p {
        font-size: 15px;
      }
    }`}
  </style>

  <div className="terms-header">
    {/* <img src="your-icon.png" alt="Terms Icon" /> */}
    <h1>📜 Terms and Conditions</h1>
  </div>

  <div className="terms-content" style={{lineHeight:1.1, maxWidth:'100%'}}>
    <h2>1. Acceptance of Terms</h2>
    <p>
      By registering your hotel or restaurant on our platform and using our dispatch
      services, you agree to these Terms and Conditions. If you do not agree, please
      refrain from using the app.
    </p>

    <h2>2. Role of the App</h2>
    <p>
      The app serves as a platform to connect your business with independent delivery
      partners. We do not guarantee delivery times, availability of dispatchers, or
      uninterrupted service.
    </p>

    <h2>3. Independent Contractors</h2>
    <p>
      All delivery partners using our platform are independent contractors. They are not
      employees, agents, or representatives of your company. We do not control or
      supervise their actions or delivery methods.
    </p>

    <h2>4. Liability Disclaimer</h2>
    <p>
      We are not responsible for mistakes, delays, or negligence by delivery partners.
      If a delivery partner is unavailable, we are not liable for any resulting loss.
    </p>

    <h2>5. Legal Compliance</h2>
    <p>
      You must ensure that all items dispatched comply with applicable laws and
      regulations. You must not request delivery of illegal or restricted items.
    </p>

    <h2>6. Review and Rating System</h2>
    <p>
      Our platform includes a review and rating mechanism that allows businesses to
      evaluate delivery partners based on performance and reliability.
    </p>

    <h2>7. Data Usage</h2>
    <p>
      We may collect and process order data, location information, and usage metrics to
      improve service quality. All data is handled in accordance with our Privacy Policy.
    </p>

    <h2>8. Termination</h2>
    <p>
      We reserve the right to suspend or terminate your access to the platform for
      violations of these terms or misuse of the service.
    </p>

    <h2>9. Changes to Terms</h2>
    <p>
      These Terms and Conditions may be updated periodically. Continued use of the app
      implies acceptance of any changes.
    </p>

    <h2>10. Governing Law</h2>
    <p>
      These terms are governed by the laws of your jurisdiction.
    </p>
  </div>
</div>


  );
}